{
    "rapormusteridetay": {
        "Baslik": "Customer Detail Report",
        "ID": "#",
        "Musteri": "Customer",
        "Referans": "Reference",
        "Kullanici": "User",
        "Randevu": "R",
        "SatisOnayli": "A",
        "SatisOnaysiz": "U",
        "SatisIptal": "C",
        "SatisCayma": "W",
        "UrunSayisi": "P",
        "UrunSayisiTam": "Product Count",
        "Olusturan": "Created By",
        "Olusturma": "Created At",
        "Ad": "First Name",
        "Soyad": "Last Name",
        "Cep": "Mobile",
        "ExcelAktar": "Export Excel",
        "Ara": "Search",
        "MusteriDetay": "Customer Detail",
        "Bilgisi": "Info",
        "Randevular": "Appointments",
        "Satislar": "Sales",
        "Loglar": "Logs",
        "Aktarma": "Transfer",
        "GeciciYetki": "Temp Authority",
        "Tasi": "Move",
        "Guncelle": "Update",
        "Kapat": "Close",
        "Tarih": "Date",
        "Saat": "Time",
        "Gorusme": "Contact",
        "Ulasim": "Transport",
        "Sonuc": "Result",
        "Aciklama": "Description",
        "SigortaEttiren": "Policy Holder",
        "Urun": "Product",
        "PoliceNo": "Policy No",
        "TutarTL": "Amount (₺)",
        "TutarDolar": "Amount ($)",
        "Kur": "Rate",
        "Ape": "Ape",
        "Not": "Note",
        "Durum": "Status",
        "Filtrele": "Filter",
        "MusteriBilgileri": "Customer Information",
        "KendiKayitlarim": "My Records",
        "TakimKayitlarim": "Team Records",
        "SubeKayitlarim": "Branch Records",
        "TumKayitlar": "All Records",
        "Gorunum": "View",
        "MusteriAdSoyad": "Customer Name / Surname",
        "Takim": "Team",
        "Sube": "Branch",
        "OlusturmaBaslangic": "Created Start",
        "OlusturmaBitis": "Created End",
        "SatisBilgileri": "Sales Information",
        "OnayliSatisFiltresi": "Approved Sales Filter",
        "Kriter": "Criteria",
        "Deger": "Value",
        "UrunSecimi": "Product Selection",
        "SatisBaslangic": "Sales Start",
        "SatisBitis": "Sales End",
        "RandevuBilgileri": "Appointment Information",
        "RandevuFiltresi": "Appointment Filter",
        "RandevuBaslangic": "Appointment Start",
        "RandevuBitis": "Appointment End",
        "Sifirla": "Reset",
        "RandevuSayisi": "Appointment Count",
        "OnaysizSatis": "Unapproved Sales",
        "OnayliSatis": "Approved Sales",
        "IptalSatis": "Cancelled Sales",
        "CaymaSatis": "Withdrawal Sales",
        "Esittir": "Equals (=)",
        "BuyukEsittir": "Greater Than or Equal (>=)",
        "Kucuk": "Less Than (<)",
        "KucukEsittir": "Less Than or Equal (<=)"
    }
}
